export const ActionTypes = {
  LOADING: "LIST_TEMPLATE_LOADING",
  ERROR: "LIST_TEMPLATE_LOADING_ERROR",
  SUCCESS: "LIST_TEMPLATE_LOADING_SUCCESS",
};
